export const PREFIX = 'nt-'

export const getNeatClassName = (name: string) => `${PREFIX}${name}`

export default {}
